import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@/components';
import { useBreadcrumbs } from '@/features/header';
import { OpportunitiesContent } from '@/features/opportunities';
import { useNavigate } from 'react-router-dom';

export function Opportunities() {
  const { t } = useTranslation(['opportunities']);
  useBreadcrumbs(() => [{ title: t(`Opportunities`) }]);

  const navigate = useNavigate();

  const handleResetFilters = useCallback(() => {
    navigate('/?page=1', { replace: true });
  }, [navigate]);

  return (
    <Container size="xl" className="overflow-hidden">
      <div className="mx-auto flex flex-col space-y-3 lg:px-4 px-1 py-4">
        <OpportunitiesContent onResetFilters={handleResetFilters} />
      </div>
    </Container>
  );
}
